// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\TransactionListResponse

import { hydrateTransaction, type Transaction, type TransactionApiResponse } from './transaction.gen';

export type TransactionListApiResponse = {
	items: TransactionApiResponse[];
};

export type TransactionList = {
	items: Transaction[];
};

export function hydrateTransactionList(data: TransactionListApiResponse): TransactionList {
	return {
		...data,
		items: data.items.map(hydrateTransaction),
	};
}